import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4c1847d5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "login-sub-page" }
const _hoisted_2 = { class: "login-page-form-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_landing_page_login_form = _resolveComponent("landing-page-login-form")!
  const _component_base_typography = _resolveComponent("base-typography")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_landing_page_login_form, { class: "login-form ava-shadow" }),
      _createVNode(_component_base_typography, {
        subtitle3: "",
        class: "version"
      }, {
        default: _withCtx(() => [
          _createTextVNode(" version: " + _toDisplayString(_ctx.version), 1)
        ]),
        _: 1
      })
    ])
  ]))
}